import { useEffect, useState } from "react";
import { BreakPoints } from "rujira.ui";

// The SCSS side switches to desktop at `min-width: $medium`, so the mobile
// side has to stop just short of it or both rules apply on the boundary pixel.
const below = (breakpoint: number) => `(max-width: ${breakpoint - 0.02}px)`;

const evaluate = (q: string): boolean =>
  typeof window === "undefined" ? false : window.matchMedia(q).matches;

function useMediaQuery(q: string): boolean {
  const [matches, setMatches] = useState(() => evaluate(q));

  useEffect(() => {
    const list = window.matchMedia(q);
    const sync = () => setMatches(list.matches);
    // The viewport may have changed between render and effect.
    sync();
    list.addEventListener("change", sync);
    return () => list.removeEventListener("change", sync);
  }, [q]);

  return matches;
}

// Correct on the very first render, and only re-renders when the breakpoint is
// actually crossed — unlike useWindowSize, which starts at 0 and fires on every
// resize event.
export const useIsBelow = (breakpoint: number): boolean =>
  useMediaQuery(below(breakpoint));

export const useIsMobile = (): boolean => useIsBelow(BreakPoints.medium);
